import { Grid } from '@mui/material'
import type { FC } from 'react'
import { useCallback } from 'react'

import OfferedBidForm from '@/features/bidding/components/capacity/offer/OfferedBidForm'
import PastBidPtusDataGrid from '@/features/bidding/components/capacity/offer/PastBidPtusDataGrid'
import { useBidOfferDataContext } from '@/features/bidding/contexts/BidOfferDataContext'
import type { BidMetaData, ExtendedBidPtu } from '@/features/bidding/types/bid'

type Props = {
  bidMetaData: BidMetaData
}

const CreateBidForm: FC<Props> = ({ bidMetaData }) => {
  const { copyPastPtusForActivationGroup } = useBidOfferDataContext()

  const copyPastPtus = useCallback(
    (ptus: ExtendedBidPtu[]) => {
      if (ptus.length > 0) {
        copyPastPtusForActivationGroup(bidMetaData.activationGroupUuid, ptus)
      }
    },
    [copyPastPtusForActivationGroup, bidMetaData.activationGroupUuid],
  )

  return (
    <Grid container data-testid={`activation-group-bid-${bidMetaData.activationGroupUuid}`} spacing={2}>
      <Grid size={{ xs: 5 }}>
        <PastBidPtusDataGrid bidMetaData={bidMetaData} copyPtusToBid={copyPastPtus} />
      </Grid>
      <Grid data-testid={'BiddingForm'} size={{ xs: 7 }}>
        <OfferedBidForm bidMetaData={bidMetaData} />
      </Grid>
    </Grid>
  )
}

export default CreateBidForm
